import { Serializable } from "@/core/api/decorators/serializable_decorator"
import {
  PriceCategoryBaseModel,
  PriceCategoryBaseData,
} from "./priceCategoryBaseModel"
import { PriceType } from "../../constants/priceType"
import { IsNumber, IsPositive } from "class-validator"

@Serializable
export class PriceCategoryFixedModel extends PriceCategoryBaseModel {
  priceType: PriceType.Fixed = 1
  @IsNumber(
    { allowNaN: false, allowInfinity: false, maxDecimalPlaces: 0 },
    {
      message: "form.errors.empty",
      groups: ["create_category"],
    },
  )
  @IsPositive({
    message: "price_fixed_error",
    groups: ["price_table"],
  })
  amount: number = 0

  constructor(
    data:
      | (Omit<PriceCategoryBaseData, "priceType"> & {
          priceType: PriceType.Fixed
          amount: number
          numConsultants?: number
          hourlyRateOverwrite?: number
        })
      | null = null,
  ) {
    super(data)
    if (data) {
      this.amount = data.amount
    }
  }
}
